import React, { useState } from "react";
import "./index.css";
import {
  ArrowBackIcon,
  CalendarIcon,
  EmailIcon,
  ExperienceIcon,
  JobTypeIcon,
  Location2Icon,
  LocationIcon,
  NextIcon,
  PhoneIcon,
  PreviousIcon,
  ProfileIcon,
  SalaryIcon,
  ShareIcon,
  ShowerIcon,
  WhatsappIcon,
} from "../../components/icons";
import Position from "../../images/position.jpg";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useGetClassifiedQuery, useViewImpressionClassifiedMutation } from "../../features/supabase/usecase/classifieds";
import storageService from "../../app/services/storageService";
import { RWebShare } from "react-web-share";
import { JobTile } from "../../components";

const JobDetailPage = () => {
  const params = useParams();
  const {
    data: job,
    error,
    isLoading,
  } = useGetClassifiedQuery(parseInt(params.id));

  const formatPhoneNumber = (phoneNumberString) => {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + ' ' + match[3];
    }
    return phoneNumberString;
  };

  const images = [
    "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg",
    "https://images.pexels.com/photos/268533/pexels-photo-268533.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
  ];

  const navigate = useNavigate();


  const [viewImpressionClassified] = useViewImpressionClassifiedMutation();


  const handleBack = () => {
    navigate(-1);
  };

  if (isLoading) {
    return (
      <section className="loader-section">
        <span className="loader"> </span>
      </section>
    );
  }

  if (job.status === "deleted") {
    return (
      <div className="listing-detail-container">
        <div className="back-button" onClick={handleBack}>
          <ArrowBackIcon size={19} fill={"black"} />
          <div>Back</div>
        </div>
        <div className="listing-header">
          <div>
            <div className="listing-detail-title">Job Listing deleted. Kindly contact admin.</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="job-detail-container">
      <div className="listing-action-buttons">
        <div className="back-button" onClick={handleBack}>
          <ArrowBackIcon size={19} fill={"black"} />
          <div>Back</div>
        </div>
      </div>
      <div className="job-header">
        {job?.properties?.images.length > 0 && (
          <img src={`${storageService.publicUrl(job.properties.images[0])}`} />
        )}
        <div>
          <div className="job-detail-title">{job.title}</div>
          <div className="job-detail-info">
            {job?.properties?.city && <div className="job-detail-info-row">
              <Location2Icon size={21} />
              <div className="job-detail-info-row-text">
                {job.properties.city}
              </div>
            </div>}
            <div className="job-detail-info-row">
              <CalendarIcon size={21} />
              <div className="job-detail-info-row-text">
                {new Date(job.created_at).toDateString()}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="job-features">
        <div className="job-feature">
          <JobTypeIcon size={24} />
          <div>
            <div className="job-feature-title">Job Type</div>
            <div className="job-feature-info">Full Time</div>
          </div>
        </div>
        <div className="job-feature">
          <img src={Position} />
          <div>
            <div className="job-feature-title">Position</div>
            <div className="job-feature-info">Remote</div>
          </div>
        </div>
        <div className="job-feature">
          <ExperienceIcon size={24} fill={"transparent"} />
          <div>
            <div className="job-feature-title">Experience</div>
            <div className="job-feature-info">Expert</div>
          </div>
        </div>
        {job.properties?.salary && (
          <div className="job-feature">
            <SalaryIcon size={24} fill={"transparent"} />
            <div>
              <div className="job-feature-title">Salary</div>
              <div className="job-feature-info">${job.properties?.salary}</div>
            </div>
          </div>
        )}
      </div> */}
      {job.description && <div className="description-section">
        <div className="description-title">Description:</div>
        <div
          dangerouslySetInnerHTML={{ __html: job.description }}
          className="description"
        />
      </div>}
      <div className="listed-by-section">
        <div className="listed-by-title">Listed by:</div>
        {/* <div className='listed-by-info'>
                            <ProfileIcon size={45} stroke={"#3A3A3A"} fill={"#fff"} />
                            <div>Mendel Gady</div>
                        </div> */}
        <div className="contact-info">
          <NavLink
            to={"mailto:" + job.email}
            className="contact-info-row"
          >
            <EmailIcon size={30} />
            <div>{job.email}</div>
          </NavLink>
          {job.phone && <NavLink
            to={"tel:" + job.phone}
            className="contact-info-row"
          >
            <PhoneIcon size={30} />
            <div>{formatPhoneNumber(job.phone)}</div>
          </NavLink>}
          {job.whatsapp && <NavLink
            to={"tel:" + job.whatsapp}
            className="contact-info-row"
          >
            <WhatsappIcon size={30} />
            <div>{formatPhoneNumber(job.whatsapp)}</div>
          </NavLink>}
        </div>
      </div>
      {job.whatsapp && (<a href={"https://api.whatsapp.com/send?phone=" + job.whatsapp} className="floating-button">
        <WhatsappIcon size={40} />
      </a>)}

      <span
        className="text-medium flex-row"
        style={{
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <span className="bold">Similar Listings</span>
      </span>
      <div style={{ display: "flex", gap: "20px", overflow: "auto", width: "100%", padding: "10px", marginBottom: "20px" }}>
        {
          job.categories.similars.map((classified, i) => {
            return (
                <JobTile
                  key={i}
                  location={classified?.locations?.location}
                  price={classified?.properties?.salary}
                  title={classified.title}
                  description={classified.description}
                  id={classified.id}
                  postedOn={classified.created_at}
                  onIntersection={(event, unobserve) => {
                    if (event.isIntersecting) {
                      viewImpressionClassified(classified.id);
                      unobserve();
                    }
                  }} />
                )
          })
        }
      </div>
    </div>
  );
};

export default JobDetailPage;
